import {
  TbBuildingStore,
  TbCar,
  TbPill,
  TbShoppingCart,
  TbToolsKitchen2,
  TbWifi,
} from "react-icons/tb";

export const VOUCHER_CATEGORY_DEFS = [
  { id: "supermarket", label: "Supermercado", icon: TbShoppingCart, totalCents: 100000 },
  { id: "fuel", label: "Combustível", icon: TbCar, totalCents: 40000 },
  { id: "internet", label: "Internet", icon: TbWifi, totalCents: 15000 },
  { id: "pharmacy", label: "Farmácia", icon: TbPill, totalCents: 25000 },
  { id: "meal", label: "Refeição", icon: TbToolsKitchen2, totalCents: 70000 },
  { id: "culture", label: "Cultura", icon: TbBuildingStore, totalCents: 10000 },
];

export const INITIAL_VOUCHER_BALANCES = {
  supermarket: 85000,
  fuel: 32000,
  internet: 12000,
  pharmacy: 20000,
  meal: 56000,
  culture: 9000,
};

export const VOUCHER_STATEMENTS = {
  supermarket: [
    { id: "1", title: "Extra Hipermercado", date: "05/06/2026 · 14:32", amountCents: -8990 },
    { id: "2", title: "Pão de Açúcar", date: "02/06/2026 · 19:10", amountCents: -12450 },
    { id: "3", title: "Carrefour", date: "28/05/2026 · 11:05", amountCents: -6780 },
  ],
  fuel: [
    { id: "1", title: "Posto Shell", date: "04/06/2026 · 08:15", amountCents: -15000 },
    { id: "2", title: "Ipiranga", date: "30/05/2026 · 17:40", amountCents: -20000 },
  ],
  internet: [
    { id: "1", title: "Vivo Fibra", date: "01/06/2026 · 09:00", amountCents: -9990 },
  ],
  pharmacy: [
    { id: "1", title: "Drogasil", date: "03/06/2026 · 16:22", amountCents: -4590 },
    { id: "2", title: "Pacheco", date: "25/05/2026 · 10:18", amountCents: -3210 },
  ],
  meal: [
    { id: "1", title: "Restaurante Sabor", date: "05/06/2026 · 12:45", amountCents: -3890 },
    { id: "2", title: "iFood", date: "04/06/2026 · 20:30", amountCents: -5620 },
  ],
  culture: [
    { id: "1", title: "Cinemark", date: "31/05/2026 · 21:00", amountCents: -5400 },
  ],
};

export const buildVoucherCategories = (balances) =>
  VOUCHER_CATEGORY_DEFS.map((def) => {
    const balanceCents = balances[def.id] ?? 0;
    const percent =
      def.totalCents > 0
        ? Math.min(100, Math.round((balanceCents / def.totalCents) * 100))
        : 0;

    return { ...def, balanceCents, percent };
  });

export const getTotalVoucherBalance = (balances) =>
  Object.values(balances).reduce((sum, value) => sum + value, 0);
